import { render, staticRenderFns } from "./ChoiceCard.vue?vue&type=template&id=39deee3a&"
import script from "./ChoiceCard.vue?vue&type=script&lang=js&"
export * from "./ChoiceCard.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceCard.vue?vue&type=style&index=0&module=%24s&lang=css&"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports